// Express mediates profiles. Importing this module does not construct Supabase.
export const CARRIER_NOT_FOUND_MESSAGE = 'این مورد پیدا نشد. ممکن است متعلق به اپراتور دیگری باشد؛ اپراتور را از بالای صفحه بررسی کنید.';
async function authHeaders(json = false) {
  const { supabase } = await import('./supabaseClient');
  const { data: { session } } = await supabase.auth.getSession();
  const headers = json ? { 'Content-Type': 'application/json' } : {};
  if (session && session.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  return headers;
}
async function call(method, path, body) {
  let resp;
  try {
    const headers = await authHeaders(!!body);
    resp = await fetch(`/api/design/profiles${path}`, {
      method, headers, body: body ? JSON.stringify(body) : undefined,
    });
  } catch (error) { if (error.name === 'AbortError') throw error; return { error: 'خطای شبکه.' }; }
  const data = await resp.json().catch(() => null);
  if (resp.status === 404) return { error: CARRIER_NOT_FOUND_MESSAGE };
  if (!resp.ok) return { error: (data && data.error) || 'درخواست پیش‌تنظیم انجام نشد. دوباره تلاش کنید.' };
  return data || {};
}
export const listProfiles = () => call('GET', '');
export const createProfile = (body) => call('POST', '', body);
export const updateProfile = (id, body) => call('PATCH', `/${id}`, body);
export const deleteProfile = (id) => call('DELETE', `/${id}`);
export const interviewProfile = ({ messages, draft }) => call('POST', '/interview', { messages, draft });

export const copySources = () => call('GET', '/copy-sources');
export const copyProfile = (carrierId, profileId) => call('POST', '/copy', { carrier_id: carrierId, profile_id: profileId });
